import { useState ,useEffect} from 'react'
import Card from './shared/card'
import Button from './shared/Button'
import RatingSelect from './RatingSelect'
import AboutIconPage from './AboutIconLink'
import {useContext} from 'react'
import FeedbackContext from '../context/FeedBackContext'


function FeedbackForm(){
    const[text,setText]=useState('')
    const[rating,setRating]=useState(10)
    const[btnDisabled,setBtnDisabled]=useState(true)
    const[message,setMessage]=useState('')
    const {addFeedback ,feedbackEdit,updateFeedback}=useContext(FeedbackContext)

    useEffect(()=>{
        if(feedbackEdit.edit===true){
            setBtnDisabled(false)
            setText(feedbackEdit.item.text)
            setRating(feedbackEdit.item.rating)
        }
    },[feedbackEdit])


    const handleTextChange=(e)=>{
        if(text===''){
            setBtnDisabled(true)
            setMessage(null)
        }else if(text!=='' && text.trim().length<=10){
             setMessage('Text is less than 10 characters ')
             setBtnDisabled(true)
        }else{
            setMessage(null)
            setBtnDisabled(false)
        }
        setText(e.target.value)
    }

    const handleSubmit=(e)=>{
        e.preventDefault();
        if(text.trim().length>10){
            const newfeedback={
                text,
                rating
            }
            if(feedbackEdit.edit===true){
                updateFeedback(feedbackEdit.item.id,newfeedback)
            }else{
                addFeedback(newfeedback)

            }
            setText('')
        }


    } 
    
    return (
        <Card>
            <form onSubmit={handleSubmit}>
            <h2>How would you rate ?  </h2>
            <RatingSelect select={(rating)=>setRating(rating)}/>
            <div className="input-group">
                <input value={text} onChange={handleTextChange} type="text" placeholder='Write a Review' />
                <Button type="submit" version='secondary' isDisabled={btnDisabled}>Send</Button>
            </div>
            {message && <div className='message'>{message}</div>}
            </form>
            <AboutIconPage/>
        </Card>
     
    )
}

export default FeedbackForm